'use strict';

productSearchRequest.$inject = ["Enums", "queryStringHelper"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productSearchRequest = productSearchRequest;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function productSearchRequest(Enums, queryStringHelper) {
    var clazz = function ProductSearchRequest() {
        var defaults = {
            Skip: 0,
            Take: 5,
            SortByField: '',
            SortAsc: true,
            context: Enums.searchContext.none.id,
            Name: '',
            OnlyDiscounts: true,
            CategoryFilters: [],
            SellerIds: []
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        addCategoryFilter: function addCategoryFilter(categoryType, selectedId) {
            var item = _lodash2.default.find(this.CategoryFilters, {
                CategoryType: categoryType
            });
            if (item) {
                item.CategoryIds.push(selectedId);
            } else {
                this.CategoryFilters.push({
                    CategoryType: categoryType,
                    CategoryIds: [selectedId]
                });
            }
        }
    });

    clazz.createForHomePage = function () {
        var request = new clazz();
        request.Skip = 0;
        request.Take = 5;
        request.SortByField = 'DiscountDate';
        request.SortAsc = false;
        request.context = Enums.searchContext.discount.id;
        request.Name = '';
        request.OnlyDiscounts = true;
        request.CategoryFilters = [];
        request.SellerIds = [];
        return request;
    };

    clazz.createForDiscounts = function (params, discountTypeId) {
        var request = new clazz();
        request.Skip = params.skip;
        request.Take = params.take;
        request.SortByField = params.sortByField;
        request.SortAsc = params.sortAsc;
        request.context = Enums.searchContext.discount.id;
        request.Name = '';
        request.DiscountTypeIds = [discountTypeId];
        // TODO Make this correct again, changed for demo
        request.OnlyDiscounts = true; //queryStringHelper.getDiscountsOnly(params.filter);
        request.CategoryFilters = queryStringHelper.getCategoryFilters(params.filter);
        request.SellerIds = queryStringHelper.getSellerIds(params.filter);
        return request;
    };

    clazz.createForSearch = function (params, searchValue) {
        var request = new clazz();
        request.Skip = params.skip;
        request.Take = params.take;
        request.SortByField = params.sortByField;
        request.SortAsc = params.sortAsc;
        request.context = Enums.searchContext.search.id;
        request.Name = searchValue;
        request.OnlyDiscounts = queryStringHelper.getDiscountsOnly(params.filter);
        request.CategoryFilters = queryStringHelper.getCategoryFilters(params.filter);
        request.SellerIds = queryStringHelper.getSellerIds(params.filter);
        return request;
    };

    clazz.createForBrand = function (params, brandId) {
        var request = new clazz();
        request.Skip = params.skip;
        request.Take = params.take;
        request.SortByField = params.sortByField;
        request.SortAsc = params.sortAsc;
        request.context = Enums.searchContext.brand.id;
        request.Name = '';
        request.OnlyDiscounts = queryStringHelper.getDiscountsOnly(params.filter);
        request.CategoryFilters = queryStringHelper.getCategoryFilters(params.filter);
        // add brand to CategoryFilters
        request.CategoryFilters.push({
            CategoryType: Enums.categoryType.brand.id,
            categoryIds: [brandId]
        });
        request.SellerIds = queryStringHelper.getSellerIds(params.filter);
        return request;
    };

    clazz.createForCategory = function (params, categoryId) {
        var request = new clazz();
        request.Skip = params.skip;
        request.Take = params.take;
        request.SortByField = params.sortByField;
        request.SortAsc = params.sortAsc;
        request.context = Enums.searchContext.category.id;
        request.Name = '';
        request.OnlyDiscounts = queryStringHelper.getDiscountsOnly(params.filter);

        if (categoryId !== 0) {
            request.CategoryFilters = queryStringHelper.getCategoryFilters(params.filter);
            // add category to CategoryFilters
            request.addCategoryFilter(Enums.categoryType.category.id, categoryId);
        } else if (params.filter !== '') {
            request.CategoryFilters = queryStringHelper.getCategoryFilters(params.filter);
        } else {
            request.CategoryFilters = null;
        }

        request.SellerIds = queryStringHelper.getSellerIds(params.filter);
        return request;
    };

    clazz.createForSellerProducts = function (params, sellerId, categoryId) {
        var request = new clazz();
        request.Skip = params.skip;
        request.Take = params.take;
        request.SortByField = params.sortByField;
        request.SortAsc = params.sortAsc;
        request.context = Enums.searchContext.sellerProducts.id;
        request.Name = '';
        request.OnlyDiscounts = queryStringHelper.getDiscountsOnly(params.filter);
        request.SellerIds = [sellerId];

        if (categoryId !== 0 && categoryId) {
            request.CategoryFilters = queryStringHelper.getCategoryFilters(params.filter);
            // add category to CategoryFilters
            request.addCategoryFilter(Enums.categoryType.category.id, categoryId);
        } else if (params.filter !== '') {
            request.CategoryFilters = queryStringHelper.getCategoryFilters(params.filter);
        } else {
            request.CategoryFilters = null;
        }

        return request;
    };

    clazz.createForSellerDiscounts = function (params, sellerId) {
        var request = new clazz();
        request.Skip = params.skip;
        request.Take = params.take;
        request.SortByField = params.sortByField;
        request.SortAsc = params.sortAsc;
        request.context = Enums.searchContext.seller.id;
        request.Name = '';
        request.OnlyDiscounts = true;
        request.CategoryFilters = queryStringHelper.getCategoryFilters(params.filter);
        request.SellerIds = [sellerId];
        request.DiscountTypeIds = queryStringHelper.getDiscountTypes(params.filter);
        return request;
    };

    clazz.createForSellerCategory = function (params, sellerId, sellerCategoryId) {
        var request = new clazz();
        request.Skip = params.skip;
        request.Take = params.take;
        request.SortByField = params.sortByField;
        request.SortAsc = params.sortAsc;
        request.context = Enums.searchContext.seller.id;
        request.Name = '';
        request.OnlyDiscounts = queryStringHelper.getDiscountsOnly(params.filter);
        request.CategoryFilters = queryStringHelper.getCategoryFilters(params.filter);
        request.addCategoryFilter(Enums.categoryType.seller.id, sellerCategoryId);
        request.SellerIds = [sellerId];
        return request;
    };

    clazz.createForSellerDetailDiscounts = function (sellerId) {
        var request = new clazz();
        request.Skip = 0;
        request.Take = 5;
        request.SortByField = 'DiscountDate';
        request.SortAsc = false;
        request.context = Enums.searchContext.seller.id;
        request.Name = '';
        request.OnlyDiscounts = true;
        request.CategoryFilters = [];
        request.SellerIds = [sellerId];
        return request;
    };

    clazz.createForSellerDetailProducts = function (sellerId) {
        var request = new clazz();
        request.Skip = 0;
        request.Take = 5;
        request.SortByField = 'Date';
        request.SortAsc = false;
        request.context = Enums.searchContext.seller.id;
        request.Name = '';
        request.OnlyDiscounts = false;
        request.CategoryFilters = [];
        request.SellerIds = [sellerId];
        return request;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/productSearchRequest.js
// module id = 778
// module chunks = 0